// ────────────────────────────────────────────────────────────────────
// desktopMode — "Situs Desktop" ala browser HP.
//
// Cara kerja: menukar isi <meta name="viewport">. Mode HP pakai
// `width=device-width` (responsif normal); mode Desktop memaksa lebar
// virtual tetap (DESKTOP_WIDTH) sehingga HP merender tampilan desktop
// lalu di-zoom-out — user bisa cubit-zoom & geser lihat tabel penuh.
//
// Pilihan disimpan di localStorage (namespace ft-*) dan diterapkan
// sekali saat startup (initDesktopMode) supaya tak ada kedip.
// ────────────────────────────────────────────────────────────────────

const KEY = 'ft-desktop-mode';
const DESKTOP_WIDTH = 1280; // lebar virtual saat mode desktop
const MOBILE_VIEWPORT = 'width=device-width, initial-scale=1, viewport-fit=cover';
const DESKTOP_VIEWPORT = `width=${DESKTOP_WIDTH}, viewport-fit=cover`;

export function isDesktopMode() {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

function applyViewport(desktop) {
  if (typeof document === 'undefined') return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  meta.setAttribute('content', desktop ? DESKTOP_VIEWPORT : MOBILE_VIEWPORT);
}

export function setDesktopMode(desktop) {
  try {
    localStorage.setItem(KEY, desktop ? '1' : '0');
  } catch {}
  applyViewport(desktop);
}

// Panggil sekali di startup (index.js) — terapkan pilihan tersimpan.
export function initDesktopMode() {
  applyViewport(isDesktopMode());
}
